import React from "react";
import { MapPin, Phone, Mail, Building2, ExternalLink } from "lucide-react";

const ContactSection = () => {
  // Google Form embed URL (converted from viewform link)
  const googleFormEmbedUrl = "https://docs.google.com/forms/d/e/1FAIpQLScW_508zbPj33EjAnc7SJXNX9fdp6zVQj-Xy4aEtzdn2KGqfA/viewform?embedded=true";

  return (
    <section id="contact" className="section-padding relative overflow-hidden reveal">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/11054301/pexels-photo-11054301.jpeg"
          alt="Industrial Equipment"
          className="w-full h-full object-cover opacity-10"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-50/98 via-white/98 to-red-50/98"></div>
      </div>

      <div className="container-custom relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#8B1538] font-semibold text-sm uppercase tracking-wider">Get In Touch</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Contact Us
          </h2>
          <p className="text-xl text-gray-600 leading-relaxed">
            Ready to enhance your printing quality with our UV & LED coating solutions? Reach out for expert consultation, custom quotes, or dealership inquiries.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-8">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Contact Information</h3>
              
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-lg flex-shrink-0">
                    <MapPin className="h-6 w-6 text-[#8B1538]" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Address</h4>
                    <p className="text-gray-600 leading-relaxed">
                      G-12, 13, Bajrang Bali Audyogic Asthan<br />
                      Raniganj, Site-4 Panki<br />
                      Kanpur, Uttar Pradesh, India
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-lg flex-shrink-0">
                    <Phone className="h-6 w-6 text-[#8B1538]" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Phone</h4>
                    <p className="text-gray-600">+91 7706994400</p>
                    <p className="text-sm text-gray-500 mt-1">Mon-Sat: 9:00 AM - 6:00 PM IST</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-lg flex-shrink-0">
                    <Mail className="h-6 w-6 text-[#8B1538]" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Email</h4>
                    <p className="text-gray-600">Crimson.inks7475@gmail.com</p>
                    <p className="text-gray-600">Crimsoninks.knp@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="bg-red-100 p-3 rounded-lg flex-shrink-0">
                    <Building2 className="h-6 w-6 text-[#8B1538]" />
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Company</h4>
                    <p className="text-gray-600">Crimson Inks Private Limited</p>
                    <p className="text-sm text-gray-500 mt-1">Directors: Chirag Jain & Prateek Jain</p>
                    <div className="flex items-center space-x-2 mt-2">
                      <img src="/quality-logo.png" alt="ISO 9001:2015" className="h-6 w-6" />
                      <span className="text-xs text-gray-600 font-semibold">ISO 9001:2015 Certified</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Map */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-100 p-4 overflow-hidden">
              <a
                href="https://maps.app.goo.gl/7uaGfncR36pKhG4f6"
                target="_blank"
                rel="noopener noreferrer"
                className="block relative group"
              >
                <iframe
                  title="Crimson Inks Location"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3570.489!2d80.3055!3d26.4489!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399c470d5c5c5c5c%3A0x5c5c5c5c5c5c5c5c!2sBajrang%20Bali%20Audyogic%20Asthan%2C%20G-12-13%2C%20Raniganj%2C%20Panki%2C%20Kanpur%2C%20Uttar%20Pradesh%20208020!5e0!3m2!1sen!2sin!4v1234567890"
                  width="100%"
                  height="300"
                  style={{ border: 0, borderRadius: '8px', pointerEvents: 'none' }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
                <div className="absolute inset-0 bg-transparent group-hover:bg-black/5 transition-all rounded-lg flex items-center justify-center">
                  <span className="opacity-0 group-hover:opacity-100 bg-white px-4 py-2 rounded-lg shadow-lg font-semibold text-[#8B1538] transition-opacity">
                    Click to Open in Google Maps
                  </span>
                </div>
              </a>
            </div>
          </div>

          {/* Google Form */}
          <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden">
            <div className="bg-gradient-to-r from-[#8B1538] to-[#DC143C] px-8 py-4">
              <h3 className="text-2xl font-bold text-white flex items-center">
                Send Us a Message
              </h3>
              <p className="text-white/80 text-sm mt-1">Fill out the form below and we'll get back to you shortly</p>
            </div>
            
            {/* Embedded Google Form */}
            <div className="relative bg-white">
              <iframe
                src={googleFormEmbedUrl}
                width="100%"
                height="700"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Contact Form"
                className="block"
                data-testid="google-form-embed"
                style={{ minHeight: '700px' }}
              >
                Loading…
              </iframe>
            </div>
            
            {/* Open in new tab option */}
            <div className="px-8 py-4 bg-gray-50 border-t border-gray-100">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScW_508zbPj33EjAnc7SJXNX9fdp6zVQj-Xy4aEtzdn2KGqfA/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center text-sm text-[#8B1538] hover:text-[#DC143C] font-medium transition-colors"
              >
                <ExternalLink className="h-4 w-4 mr-2" />
                Open form in new tab
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
